import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=4f4f9fa4"
import script from "./ProjectOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports